exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".scrollable-area{overflow-y:auto;overflow-x:hidden;max-height:calc(100vh - 215px);scrollbar-width:thin;padding:0 6px 0 0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"scoped":false,"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/locations/LocationEdit.vue
// module id = 851
// module chunks = 0